import React from "react";
import { Image, Image1, ImagePharmacyLogo } from "../../style/Logo";
import FirstLogo from "../../assets/logo2.jpeg";
import SecondLogo from "../../assets/ehrpnglogo.png";
import ThirdLogo from "../../assets/logo3.jpeg";
import PharmacyLogo from "../../assets/logo/PharmacyLogo.png"

export const Logo1 = ({ style, className }) => {
  return (
    <div style={style} className={className}>
      <a href="https://doceree.com">
      <Image src={FirstLogo} alt="logo" />
      </a>
    </div>
  );
};

export const PmsLogo = ({className}) => {
  return (
    <div className={className}>
      <ImagePharmacyLogo src={PharmacyLogo} alt="pharmacy logo"/>
    </div>
  )
}
export const Logo2 = ({className}) => {
  return (
    <div className={className}>
      <Image1 src={SecondLogo} alt="logo" />
    </div>
  );
};

export const Logo3 = ({className}) => {
  return (
    <div className={className}>
      <Image src={ThirdLogo} alt="logo" />
    </div>
  );
};
